import React from "react";

import Axios from 'axios';
import { Link } from "react-router-dom";

import {
  Badge,
  Button,
  Card,
  CardBody,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
  Form,
  Label,
  Input
} from "reactstrap";

import Header from "components/Header.jsx";
import Loader from "components/Loader.jsx";

class SetPassword extends React.Component {
  constructor(props) {
    console.log(props);

    super(props);

    this.unmounted = false;

    this.state = {
      'password': '',
      'repeatPassword': '',
      'loading': false,
      'disableButton': false,
      'message': ''
    }
  }

  componentWillMount() {
    document.body.classList.add('bg-red');
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  submitForgotPassword(e) {
    e.preventDefault();

    this.setState({
      'loading': true
    });

    let urlParams = {};

    if(this.props.history !== undefined && this.props.history.location.search !== undefined && this.props.history.location.search.length > 0) {
      this.props.history.location.search.replace('?', '').split('&').forEach((string) => {
        const key = string.split('=')[0];
        const value = string.split('=')[1];

        if(key !== undefined && value !== undefined) {
          urlParams[key] = value;
        }
      });
    }

    if(this.state.password !== this.state.repeatPassword) {
      this.setState({
        'message': "De twee ingevoerde wachtwoorden komen niet overeen.",
        'loading': false
      });

      return false;
    }

    if(urlParams.key !== undefined && urlParams.login !== undefined) {

      Axios.post(this.props.generic.endpoint + 'wp-json/dpg/v1/set-password', {
          'password': this.state.password,
          'key': decodeURI(urlParams.key),
          'login': decodeURI(urlParams.login)
        })
        .then( response => {
          if(this.unmounted) return;

          if(response.data) {
            if(response.data.data.ID === 2) {
              this.setState({
                'message': response.data.data.message,
                'loading': false,
                'disableButton': false
              });
            } else {
              this.setState({
                'message': response.data.data.message,
                'loading': false,
                'disableButton': true
              });
            }
          }
        })
        .catch( error => {
          if(error.response) {
            this.setState({
              'message': error.response.data.message,
              'loading': false
            });
          }
        });
    } else {
      this.setState({
        'message': 'Het resetten van het password is niet gelukt. Vraag een nieuwe resetlink aan.',
        'loading': false
      });
    }
  }

  changeInput(e) {
    if(e.target.value !== undefined && e.target.value !== null && e.target.value.length > 0) {
      e.target.classList.add('has-value');
    } else {
      e.target.classList.remove('has-value');
    }

    this.setState({
      [e.target.name]: e.target.value
    });
  }

  render() {
    return (
      <>
        <Header
          title="RSS feed wizzard"
          lead="De RSS feed wizzard helpt u om een RSS widget samen te stellen die aan uw wensen voldoet."
        />

        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Col lg="5" md="7">
              
              <Card className="bg-secondary border-0 mb-0">
                <Loader active={this.state.loading}>
                  <CardBody className="px-lg-5 py-lg-4">

                    <div className="text-center text-sm text-muted mb-4">
                      Kies een wachtwoord
                    </div>

                    <Form
                      onSubmit={this.submitForgotPassword.bind(this)}
                      className="authentication__form"
                    >
                      <div className="form-group mb-3">
                        <Label
                          htmlFor="password"
                          className="text-sm"
                        >
                          Wachtwoord
                        </Label>
                        <Input
                          type="password"
                          name="password"
                          id="password"
                          value={this.state.password}
                          onChange={this.changeInput.bind(this)}
                          className="form-group__field"
                          autoComplete="new-password" />
                      </div>

                      <div className="form-group mb-3">
                        <Label
                          htmlFor="repeatPassword"
                          className="text-sm"
                        >
                          Herhaal wachtwoord
                        </Label>
                        <Input
                          type="password"
                          name="repeatPassword"
                          id="repeatPassword"
                          value={this.state.repeatPassword}
                          onChange={this.changeInput.bind(this)}
                          className="form-group__field"
                          autoComplete="new-password" />
                      </div>

                      <div className="form-group">
                          <Button color="dark" type="submit" className="mt-3 w-100" disabled={this.state.disableButton}>
                            Wachtwoord instellen
                          </Button>
                      </div>

                      {(this.state.message !== '' &&
                        <p className="text-sm text-center text-dark mt-4 mb-2" dangerouslySetInnerHTML={{'__html': this.state.message}}></p>
                      )}
                    </Form>

                  </CardBody>
                </Loader>
              </Card>

              <Row className="mt-3">
                <Col>
                  <Link to="/" className="d-block text-center text-white text-sm text-underline">Ga naar inloggen</Link>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default SetPassword;
